import Onboarding from 'App/babel/components/Onboarding/Onboarding';
import setupComponent from 'App/babel/SetupRootComponent';

angular.module('domain.onboarding', []).config([
	'$stateProvider',
	function ($stateProvider) {
		$stateProvider.state('onboarding', {
			template: '<div></div>',
			url: '/:customerId/onboarding',
			params: {
				openFullScreen: null,
				skipInit: null,
				initialImportApp: null,
				initialSubstepId: null,
				oauthCode: null
			},
			controller: [
				'$scope',
				'$element',
				'$stateParams',
				function ($scope, $element, $stateParams) {
					setupComponent($scope, Onboarding, $element[0], $stateParams, { redux: true });
				}
			]
		});
	}
]);
